var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/decorators.js", "./utils", "i18n/i18n", "./utils/theme"], function (require, exports, lit_1, decorators_js_1, utils_1, i18n_1, theme_1) {
    "use strict";
    var _a, _b, _c;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InsightChatMessage = exports.Role = void 0;
    i18n_1 = __importDefault(i18n_1);
    var Role;
    (function (Role) {
        Role["User"] = "user";
        Role["Assistant"] = "assistant";
    })(Role || (exports.Role = Role = {}));
    class InsightChatMessage extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.role = Role.User;
        }
        get icons() {
            return this.themeDescriptor.icons;
        }
        get combinedTheme() {
            var _a, _b;
            return Object.assign(Object.assign({}, ((_a = this.baseMessageThemeDescriptor) !== null && _a !== void 0 ? _a : {})), ((_b = this.messageThemeDescriptor) !== null && _b !== void 0 ? _b : {}));
        }
        renderAvatar() {
            var _a, _b, _c, _d, _e, _f;
            const role = this.role;
            // @ts-ignore
            if (!((_a = this.combinedTheme) === null || _a === void 0 ? void 0 : _a.showAvatarIcon))
                return (0, lit_1.html) `
        <span aria-hidden="true"></span>
      `;
            const iconKey = `${role}-avatar`;
            const iconOptions = {
                color: String((0, theme_1.resolveCssVarValue)((_f = (_e = (_d = (_c = (_b = this.themeDescriptor) === null || _b === void 0 ? void 0 : _b.widgets) === null || _c === void 0 ? void 0 : _c.chat) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.assistant) === null || _f === void 0 ? void 0 : _f.avatarColor, this.themeDescriptor)),
                altText: (0, i18n_1.default)("Icon")
            };
            const iconEl = new utils_1.Icon(this.themeDescriptor.icons[iconKey]).render(iconOptions);
            if (iconEl != (0, lit_1.html) `<img src="" class="mb-icon" alt="">`) {
                return (0, lit_1.html) `
        ${iconEl}
      `;
            }
            return (0, lit_1.html) `
      <span aria-hidden="true"></span>
    `;
        }
        assignVariables() {
            // TODO: get the widgets message
        }
        shouldShowAvatar() {
            var _a, _b, _c, _d, _e;
            const theme = this.combinedTheme;
            if (!theme.showAvatarIcon)
                return false;
            const orientation = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.orientation) !== null && _a !== void 0 ? _a : theme === null || theme === void 0 ? void 0 : theme.defaultOrientation) !== null && _b !== void 0 ? _b : "left";
            const defaultOrientation = (_c = theme === null || theme === void 0 ? void 0 : theme.defaultOrientation) !== null && _c !== void 0 ? _c : "left";
            const isDefaultOrientation = orientation === defaultOrientation;
            const assistantHasIcon = !!((_d = this.icons) === null || _d === void 0 ? void 0 : _d[`${Role.Assistant}-avatar`]);
            const userHasIcon = !!((_e = this.icons) === null || _e === void 0 ? void 0 : _e[`${Role.User}-avatar`]);
            if (this.role === Role.User) {
                return userHasIcon || isDefaultOrientation;
            }
            if (this.role === Role.Assistant) {
                return isDefaultOrientation || assistantHasIcon;
            }
            return false;
        }
        render() {
            var _a;
            const theme = this.combinedTheme;
            const orientation = (_a = theme === null || theme === void 0 ? void 0 : theme.orientation) !== null && _a !== void 0 ? _a : "left";
            const showAvatar = this.shouldShowAvatar();
            return (0, lit_1.html) `
      <div
        class="message ${this.role}-message ${orientation}-oriented"
        role="group"
        aria-label="Message from ${this.role}"
      >
        <div class="message__outer">
          ${showAvatar
                ? (0, lit_1.html) `
                <div class="message__avatar">
                  ${this.renderAvatar()}
                </div>
              `
                : ""}
          <div class="inner">
            <div class="message__bubble" role="textbox" aria-readonly="true">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    `;
        }
    }
    exports.InsightChatMessage = InsightChatMessage;
    InsightChatMessage.styles = (0, lit_1.css) `
    .message__outer,
    .inner,
    message__bubble {
      min-width: 0;
      flex-shrink: 1;
    }
    :host {
      display: block;
      --message-background: var(--insight-chat-message-background);
      --message-text-color: var(--insight-chat-message-color);
      --message-avatar-color: var(--insight-chat-message-avatar-color);
      --message-border-radius: var(--insight-chat-message-border-radius);
      --message-border-width: var(--insight-chat-message-border-width);
      --message-border-color: var(--insight-chat-message-border-color);
      --message-border-style: var(--insight-chat-message-border-style);
      --message-avatar-width: var(--insight-chat-message-avatar-width);
      --message-avatar-height: var(--insight-chat-message-avatar-height);
      --message-font-family: var(--insight-chat-message-font-family);
      --message-max-width: var(--insight-chat-message-bubble-max-width);
      --message-min-width: var(--insight-chat-message-bubble-min-width);
      --message-bubble-padding: var(--insight-chat-message-bubble-padding);
    }
    .message {
      display: flex;
    }
    .message__bubble {
      color: var(--message-text-color);
      font-family: var(--message-font-family)
    }
    /* Orientation */
    .left-oriented.message {
      justify-content: flex-start;
    }
    .right-oriented.message {
      justify-content: flex-end;
    }

    .right-oriented .message__avatar {
      order: 1;
    }
    .message.left-oriented .message__outer {
      justify-content: flex-start;
    }

    .message.right-oriented .inner{
      text-align: right;
    }

    .message.right-oriented .message__outer {
      justify-content: flex-end;
    }
    /* Orientation */

    .message__outer {
      flex:1;
    }
    .message__outer {
      display: flex;
      gap: 10px;
      align-items: flex-start;
    }
    .inner {
      background: var(--message-background);
      padding: var(--message-bubble-padding);
      max-width: var(--message-max-width);
      min-width: var(--message-min-width);
      border-radius: var(--message-border-radius);
      word-break: break-word;
      box-sizing: border-box;
    }
    .message__avatar {
      flex: 0 0 var(--message-avatar-width, 16px);
      height: var(--message-avatar-height, 16px);
      max-width: var(--message-avatar-width, 16px);
      padding-top: 20px;
      padding-inline: 10px;
    }
    .message__avatar .mb-icon {
      width: 100%;
      height: 100%;
      padding: 1px;
      border-radius: 100%;
    }

    @media (max-width: 768px) {
      .message__outer {
        width: 100% !important;
      }
    }
  `;
    __decorate([
        (0, decorators_js_1.property)({ type: String }),
        __metadata("design:type", String)
    ], InsightChatMessage.prototype, "role", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object)
    ], InsightChatMessage.prototype, "themeDescriptor", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_b = typeof Mindbreeze !== "undefined" && Mindbreeze.WidgetThemes) === "function" ? _b : Object)
    ], InsightChatMessage.prototype, "messageThemeDescriptor", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_c = typeof Mindbreeze !== "undefined" && Mindbreeze.WidgetThemes) === "function" ? _c : Object)
    ], InsightChatMessage.prototype, "baseMessageThemeDescriptor", void 0);
});
